import gql from 'graphql-tag';
import { DEAL_BUILDER_QUOTE_FRAGMENT } from './fragments/dealBuilderQuote.fragment';

export const START_DEAL_BUILDER = gql`
  mutation StartDealBuilder($input: StartDealBuilderInput!) {
    dealBuilder {
      startDealBuilder(input: $input) {
        success
        error
        entity {
          proposalId
          proposalContacts {
            proposalContactsId
            proposalId
            ownerPgId
            accountContactId
          }

          proposalEquipments {
            proposalEquipmentsId
            proposalId
            equipmentId
          }

          quote {
            ...DealBuilderQuoteFields
          }
        }
      }
    }
  }
  ${DEAL_BUILDER_QUOTE_FRAGMENT}
`;
